import { render } from "./ModalInformativoTemplate.vue?vue&type=template&id=1fdd38e6&scoped=true"
import script from "./ModalInformativoTemplate.vue?vue&type=script&lang=js"
export * from "./ModalInformativoTemplate.vue?vue&type=script&lang=js"

import "./ModalInformativoTemplate.vue?vue&type=style&index=0&id=1fdd38e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdd38e6"]])

export default __exports__